import(/* webpackMode: "eager" */ "/workspace/src/app/(auth)/auth/page.tsx");
